import {Asset} from './assets'

/**
 * Minimal material storage shape needed at the UPM tree level */
export interface UpmMaterialStorage {
  upmId?: string
  capacity: number
}

export interface BaseNodeType {
  code: string
  name: string
  key?: string
}

export enum UpmDepartmentOrEquipmentType {
  Asset = 'Asset',
  MaterialStorage = 'MaterialStorage'
}

export type EntityConfigDto = {
  metadata: {
    configurationType: string
    plantId: string
    upmType: UpmEntityType
    typeUpmId: string
  }
  payload: {
    productionData: ProductionData[]
  }
}

export type ProductionData = {
  name: string
  value: string
}

export enum UpmEntityType {
  Plant = 'Plant',
  Area = 'Area',
  ProductionLine = 'ProductionLine',
  Department = 'Department',
  Equipment = 'Equipment'
}

export interface BaseNode {
  upmId: string
  itemType: UpmEntityType
  type?: BaseNodeType
  entityCodesPath?: string
  text?: string
  level?: number
}

export type PlantNode = BaseNode & {
  itemType: UpmEntityType.Plant
  plantId: string
  siteId: string
  plantName: string
  plantIdHistory: {
    plantId: string
    periodStart: string
    periodEnd: string
  }[]
  children: AreaNode[]
}

export type AreaNode = BaseNode & {
  itemType: UpmEntityType.Area
  orderGroup: number
  children: ProductionLineNode[]
}

export type ProductionLineNode = BaseNode & {
  itemType: UpmEntityType.ProductionLine
  productionLineCode: string
  children: DepartmentNode[]
}

export type DepartmentNode = BaseNode & {
  itemType: UpmEntityType.Department
  children: EquipmentNode[]
  displayValue?: string
  displayValueEnglish?: string
  isOverriden?: boolean
  sourceSystemCode?: string
  departmentOrEquipmentType?: UpmDepartmentOrEquipmentType
  enabledForPlanningItem?: Asset | UpmMaterialStorage
  isDeletedInSource?: boolean
  isDeleted?: boolean
}

export type EquipmentNode = BaseNode & {
  itemType: UpmEntityType.Equipment
  children: []
  departmentOrEquipmentType?: UpmDepartmentOrEquipmentType
  enabledForPlanningItem?: Asset | UpmMaterialStorage
  isDeletedInSource?: boolean
  source?: string
  isDeleted?: boolean
}

export type TreeNode = PlantNode | AreaNode | ProductionLineNode | DepartmentNode | EquipmentNode
